const Orders = () => import("Modules/sales/orders/views/Orders");
const OrdersForm = () => import("Modules/sales/orders/views/OrdersForm");

export default {
    children: [
        {
            path: "sales/orders",
            name: "orders",
            component: Orders,
            meta: {
                requiresAuth: true,
                title: "lang.orders",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["orders.read"],
            },
        },
        {
            path: "sales/order/:id?",
            name: "order",
            component: OrdersForm,
            meta: {
                requiresAuth: true,
                title: "lang.orders",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["orders.read"],
            },
        },
    ],
};
